export default __webpack_public_path__ + "static/media/link-variant.d36ed30e.svg";